$(function() {

    //Set default plan_type if none set
    if(!docCookies.hasItem('plan_type')) {
        docCookies.setItem('plan_type', 'monthly');
    } else {
        var plan = docCookies.getItem('plan_type');
        $('.pricing__toggle').removeClass('pricing__toggle--active');

        if(plan === 'monthly') {
            $('.pricing__toggle[data-type="monthly"]').addClass('pricing__toggle--active');
            $('.pricing__number').html('28');
            docCookies.setItem('plan_type', 'monthly');
        } else {
            $('.pricing__toggle[data-type="yearly"]').addClass('pricing__toggle--active');
            $('.pricing__number').html('24');
            docCookies.setItem('plan_type', 'yearly');
        }
    }

    $('.pricing__toggle').on('click', function(e) {
        e.preventDefault();

        //Change toggle
        $('.pricing__toggle').removeClass('pricing__toggle--active');
        $(this).addClass('pricing__toggle--active');

        if($(this).data('type') === 'monthly') {
            $('.pricing__number').html('28');
            docCookies.setItem('plan_type', 'monthly');
        } else {
            $('.pricing__number').html('24');
            docCookies.setItem('plan_type', 'yearly');
        }
    });

});